.container {
}
.paper {
  background-image: none !important;
  max-width: 500px !important;
  width: 100%;
}
.backdrop {
  background: rgba(14, 15, 20, 0.5) !important;
}
:global(.dark) {
  .backdrop {
    background: rgba(14, 15, 20, 0.85) !important;
  }

  .mobileSheetHandle {
    background: var(--pm-grey4);
  }
}
.title {
  padding: 16px 24px 6px !important;
}
.content {
  padding: 10px 20px !important;
}
.actions {
  padding: 20px 20px 10px !important;
}
.mobileSheetHandle {
  width: 71px;
  height: 6px;
  margin: 1rem auto 0;
  border-radius: 5px;
  background: var(--pm-grey10);
}

@media screen and (max-width: 600px) {
  .paper {
    width: 100%;
    max-width: 100% !important;
    margin: 0 !important;
    max-height: calc(100%) !important;
  }
  .container {
    align-items: end !important;
  }
  .content {
    overflow: visible !important;
  }
  .actions {
    padding-bottom: 40px !important;
    flex-direction: column-reverse;
  }
  .actions > * {
    margin-left: 0px !important;
  }
}
